module.exports = __webpack_public_path__ + "static/media/Retro Spaceman.04db4599.jpg";